import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { ProcedureType, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { ProcedureTypeIcon } from "../Icons/ProcedureTypeIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type ProcedureTypeSelectGroupProps = MenuSelectGroupProps<Stored<ProcedureType>> & {
	procedureTypes: Stored<ProcedureType>[]
}

export const ProcedureTypeSelectGroup = memo<ProcedureTypeSelectGroupProps>((props) => {
	const { ref, procedureTypes, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<ProcedureType>> ref={ref} {...rest}>
			{procedureTypes.map((procedureType) => {
				return (
					<SelectItemTemplate<Stored<ProcedureType>> key={procedureType.uuid} value={procedureType}>
						<ProcedureTypeIcon procedureTypeId={procedureType.uuid} inline />
						<Text className="truncate">{procedureType.name}</Text>
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})

ProcedureTypeSelectGroup.displayName = "ProcedureTypeSelectGroup"
